import { useEffect, useState } from "react";

const DE = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    return (
      <img
        src={`${window.location.origin}/assets/rules/${isMobile ? "puntentelling-de-mobile.png" : "puntentelling-de.png"}`}
        className="w-full h-auto"
        alt="Puntentelling"
      />
    );
}

export default DE